import appDownload from './appDownload'
import common from './common'
import dailyTask from './dailyTask'
import dataDeletion from './dataDeletion'
import deviceHelpQa from './deviceHelpQa'
import digitalLifeQa from './digitalLifeQa'
import home from './home'
import notFound from './notFound'
import personalInfoCollection from './personalInfoCollection'
import privacyPolicy from './privacyPolicy'
import registerHelp from './registerHelp'
import thirdPartySharing from './thirdPartySharing'
import userAgreement from './userAgreement'
import newbieTask from './newbieTask'

export default [
  common,
  appDownload,
  home,
  newbieTask,
  dailyTask,
  deviceHelpQa,
  digitalLifeQa,
  notFound,
  privacyPolicy,
  registerHelp,
  userAgreement,
  dataDeletion,
  thirdPartySharing,
  personalInfoCollection
]
